import { MemoryRouter as Router } from 'react-router-dom';


function AppWrapper(props: { children?: JSX.Element }) {
    return (
        <Router>
            {props.children}
        </Router>
    );
}


export default AppWrapper;
